import { useQuery } from '@hooks/reactQuery';

import { getSiteIds } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TCMSitesIdsDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { CC_SITE_IDS } from '@constants/queryKeys';

export const useQuerySiteIds = ({
	nodeType,
	technology,
	vendor,
}: TCMSitesIdsDTO) => {
	const {
		data: siteIdsOptions,
		isFetching: isFetchingSiteIdsOptions,
		isLoading: isLoadingSiteIdsOptions,
	} = useQuery({
		queryKey: [
			CC_SITE_IDS, {
				nodeType,
				technology,
				vendor,
			},
		],
		queryFn: extractQueryParams(getSiteIds),
		select: (options: Array<string>) => fieldsOptionsFormatted(options),
		enabled: [!!nodeType, !!technology, !!vendor],
		...refetchOptions,
	});

	return {
		siteIdsOptions: siteIdsOptions || [],
		isLoadingSiteIdsOptions: isLoadingSiteIdsOptions && isFetchingSiteIdsOptions,
	};
};
